import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the types for the payload of loginRequest
interface LoginPayload {
    email: string;
    password: string;
}

interface AuthState {
    loading: boolean;
    error: string | null;
    refreshToken: string | null;
    accessToken: string | null;
    isSessionExpired: boolean;
}

const initialState: AuthState = {
    loading: false,
    error: null,
    refreshToken: null,
    accessToken: null,
    isSessionExpired: false,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        // Expecting the payload type of { email: string, password: string }
        loginRequest: (state, action: PayloadAction<LoginPayload>) => {
            state.loading = true;
            state.error = null;
        },
        loginSuccess: (state, action: PayloadAction<{ accessToken: string; refreshToken: string }>) => {
            state.loading = false;
            state.accessToken = action.payload.accessToken;
            state.refreshToken = action.payload.refreshToken;
        },
        loginFailure: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },
        clearAuthError: (state) => {
            state.error = null; // or ''
        },
        sessionExpired(state) {
            state.isSessionExpired = true;
        },
        resetSessionExpired(state) {
            state.isSessionExpired = false;
        },
    },
});

export const { loginRequest, loginSuccess, loginFailure, clearAuthError,sessionExpired,resetSessionExpired } = authSlice.actions;
export const authReducer = authSlice.reducer;
export const authActionTypes = authSlice.actions;
